module.exports = __webpack_public_path__ + "static/media/StripesPink.73b9f4c5.png";